var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQlFiori(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.84,
    height: 37.565,
    viewBox: "0 0 36.84 37.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.6 19.109c-1.669 1.451-7.629 7.094-7.629 13.676s5.963 12.224 7.629 13.676c1.669-1.452 7.628-7.094 7.628-13.676S42.274 20.558 40.6 19.109z",
    transform: "translate(-1089.277 -308.507) translate(1077.886 289.89)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.629 0C5.959 1.451 0 7.094 0 13.676S5.959 25.9 7.629 27.352c1.671-1.452 7.627-7.094 7.627-13.676S9.3 1.449 7.629 0z",
    transform: "translate(-1089.277 -308.507) rotate(89 390.595 733.68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.574 21.162a23.812 23.812 0 0 0 1.091 3.166c.141.27.289 1.25.471 1.3.174.073.306-1.126.306-1.126l.612-2.891.571-1.089.824-1.385L11.46 17.7l1.817-1.949a17.98 17.98 0 0 1 2.091-1.562 17.977 17.977 0 0 0-6.2-12.729L7.657 0 6.15 1.361A18.942 18.942 0 0 0 0 14.555c1.169.56 3.261 2.178 4.151 2.7.267.126-2.8-2.175-2.5-1.941a26.432 26.432 0 0 1 2.906 2.71 21.541 21.541 0 0 1 2.019 3.144z",
    transform: "translate(-1089.277 -308.507) rotate(-43 949.539 -1223.15)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQlFiori);
export default __webpack_public_path__ + "static/media/ql-fiori.02bf8c607d2d6e3ba225865a6a6be42d.svg";
export { ForwardRef as ReactComponent };